import { useState } from "react";
import { toast } from "sonner";
import { FileDown } from "lucide-react";
import { downloadFile } from "@/lib/download";

// Indian FY starts in April: FY 2025 = 1 Apr 2025 – 31 Mar 2026.
const now = new Date();
const CURRENT_FY = now.getMonth() + 1 >= 4 ? now.getFullYear() : now.getFullYear() - 1;
const FY_OPTIONS = [CURRENT_FY, CURRENT_FY - 1, CURRENT_FY - 2];

const fyLabel = (fy) => `FY ${fy}–${String((fy + 1) % 100).padStart(2, "0")}`;

/** FY picker + one-click Annual Report PDF download (P&L, Balance Sheet, Trial Balance). */
export function AnnualReportButton() {
  const [fy, setFy] = useState(CURRENT_FY);
  const [busy, setBusy] = useState(false);

  const download = async () => {
    setBusy(true);
    try {
      await downloadFile(`/reports/annual-report.pdf?fy=${fy}`, `finledger-annual-report-${fyLabel(fy).replace(" ", "")}.pdf`);
      toast.success(`Annual report ${fyLabel(fy)} downloaded`);
    } catch {
      toast.error("PDF download failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex items-stretch">
      <select
        data-testid="annual-report-fy-select"
        value={fy}
        onChange={(e) => setFy(Number(e.target.value))}
        className="border border-r-0 border-[#1A1F16] bg-transparent px-3 text-xs uppercase tracking-[0.15em] focus:outline-none"
      >
        {FY_OPTIONS.map((y) => <option key={y} value={y}>{fyLabel(y)}</option>)}
      </select>
      <button
        data-testid="annual-report-pdf-btn"
        onClick={download}
        disabled={busy}
        className="border border-[#1A1F16] px-4 py-2.5 text-xs uppercase tracking-[0.2em] hover:bg-[#1A1F16] hover:text-[#F7F5F0] flex items-center gap-2 disabled:opacity-50"
      >
        <FileDown className="w-3.5 h-3.5" /> {busy ? "Preparing…" : "Annual Report PDF"}
      </button>
    </div>
  );
}
